<template>
  <div class="page-search">
    <form>
      <div class="row">
        <div class="small-12 column">
          <h2 class="section-title">{{$t('search.label.keywords')}}</h2>
        </div>
      </div>
      <div class="row">
        <div class="small-12 column">
          <ui-textbox name="keywords"
                      :placeholder="$t('search.placeholder.keywords')"
                      v-model="localSearchConfig.keywords">
          </ui-textbox>
        </div>
      </div>

      <div class="row">
        <div class="small-12 column">
          <h2 class="section-title">{{$t('search.label.status')}}</h2>
        </div>
      </div>
      <div class="row">
        <div class="small-12 column">
          <div>
            <ui-toggle-button group="status" :model="localSearchConfig.status" v-on:change="onCheckboxChange"
                              :disabled="isLoading" name="all" ref="status.all">
              {{$t('search.button.status.all')}}
            </ui-toggle-button>
          </div>
        </div>
        <div class="small-6 column">
          <div>
            <ui-toggle-button group="status" :model="localSearchConfig.status" v-on:change="onCheckboxChange"
                              :disabled="isLoading" color="success-light" name="in-progress" ref="status.in-progress">
              {{$t('search.button.status.in-progress')}}
            </ui-toggle-button>
          </div>
        </div>
        <div class="small-6 column">
          <div>
            <ui-toggle-button group="status" :model="localSearchConfig.status" v-on:change="onCheckboxChange"
                              :disabled="isLoading" color="success-strong" name="shipped" ref="status.shipped">
              {{$t('search.button.status.shipped')}}
            </ui-toggle-button>
          </div>
        </div>
        <div class="small-6 column">
          <div>
            <ui-toggle-button group="status" :model="localSearchConfig.status" v-on:change="onCheckboxChange"
                              :disabled="isLoading" color="success-medium" name="partial-shipment" ref="status.partial-shipment">
              {{$t('search.button.status.partial-shipment')}}
            </ui-toggle-button>
          </div>
        </div>
        <div class="small-6 column">
          <div>
            <ui-toggle-button group="status" :model="localSearchConfig.status" v-on:change="onCheckboxChange"
                              :disabled="isLoading" color="danger" name="canceled" ref="status.canceled">
              {{$t('search.button.status.canceled')}}
            </ui-toggle-button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="small-12 column">
          <h2 class="section-title">{{$t('search.label.notification')}}</h2>
        </div>
      </div>
      <div class="row">
        <div class="small-6 column">
          <div v-on:change="onCheckboxChange">
            <ui-toggle-button group="flags" :model="localSearchConfig.flags" v-on:change="onCheckboxChange"
                              :disabled="isLoading" color="warning" name="delivery-date-is-different" ref="flags.delivery-date-is-different">
              {{$t('search.button.notification.delivery-date-is-different')}}
            </ui-toggle-button>
          </div>
        </div>
        <div class="small-6 column">
          <div v-on:change="onCheckboxChange">
            <ui-toggle-button group="flags" :model="localSearchConfig.flags" v-on:change="onCheckboxChange"
                              :disabled="isLoading" color="danger" name="delivery-date-has-changed" ref="flags.delivery-date-has-changed">
              {{$t('search.button.notification.delivery-date-has-changed')}}
            </ui-toggle-button>
          </div>
        </div>        
      </div>
      <div class="row">
        <div class="small-12 column">
          <h2 class="section-title">{{$t('search.label.period')}}</h2>
        </div>
      </div>
      <div class="row">
        <div class="small-6 column">
          <div v-on:change="onCheckboxChange">
            <ui-toggle-button group="period" :model="localSearchConfig.period" v-on:change="onCheckboxChange"
                              :disabled="isLoading" name="1-month" ref="period.1-month">
              {{$t('search.button.period.1-month')}}
            </ui-toggle-button>
          </div>
        </div>
        <div class="small-6 column">
          <div v-on:change="onCheckboxChange">
            <ui-toggle-button group="period" :model="localSearchConfig.period" v-on:change="onCheckboxChange"
                              :disabled="isLoading" name="3-month" ref="period.3-month">
              {{$t('search.button.period.3-month')}}
            </ui-toggle-button>
          </div>
        </div>
        <div class="small-6 column">
          <div v-on:change="onCheckboxChange">
            <ui-toggle-button group="period" :model="localSearchConfig.period" v-on:change="onCheckboxChange"
                              :disabled="isLoading" name="6-month" ref="period.6-month">
              {{$t('search.button.period.6-month')}}
            </ui-toggle-button>
          </div>
        </div>
        <div class="small-6 column">
          <div v-on:change="onCheckboxChange">
            <ui-toggle-button group="period" :model="localSearchConfig.period" v-on:change="onCheckboxChange"
                              :disabled="isLoading" name="12-month" ref="period.12-month">
              {{$t('search.button.period.12-month')}}
            </ui-toggle-button>
          </div>
        </div>
        <div class="small-12 column">
          <div v-on:change="onCheckboxChange">
            <ui-toggle-button group="period" :model="localSearchConfig.period" v-on:change="onCheckboxChange"
                              :disabled="isLoading" name="all" ref="period.all">
              {{$t('search.button.period.all')}}
            </ui-toggle-button>
          </div>
        </div>
      </div>
    </form>
    <ui-button type="normal"
               button-type="submit"
               color="primary"
               raised
               @click.native="submitSearch"
               :loading="isLoading">{{$t('search.button.submit')}}
    </ui-button>
  </div>
</template>

<script>
  import _ from 'lodash'
  import UIToggleButton from 'components/UIToggleButton'

  export default {
    name: 'page-search',
    computed: {
      isLoading () {
        return this.$store.state.searchLoading
      }
    },
    data () {
      return {
        localSearchConfig: _.cloneDeep(this.$store.state.searchConfig)
        // isLoading: this.$store.state.searchLoading
      }
    },
    methods: {
      submitSearch: function (e) {
        e.preventDefault()

        var configData = {
          keywords: this.localSearchConfig.keywords,
          status: this.localSearchConfig.status,
          flags: this.localSearchConfig.flags,
          period: this.localSearchConfig.period
        }
        this.$store.dispatch('searchOrders', configData)
      },

      onCheckboxChange: function (component) {
        this.parseSelectedValues()

        /*
          Handling the auto-check logic for status and period
        */

        switch (component.group) {
          case 'status':
            // Force unselect of other buttons than 'All'
            if (component.name === 'all' && component.isChecked) {
              this.$refs['status.in-progress'].uncheck()
              this.$refs['status.shipped'].uncheck()
              this.$refs['status.partial-shipment'].uncheck()
              this.$refs['status.canceled'].uncheck()
              this.parseSelectedValues()
            }
            else if (component.name !== 'all' && this.localSearchConfig.status.length > 0) {
              if (this.$refs['status.all'].isChecked) {
                this.$refs['status.all'].uncheck()
                this.parseSelectedValues()
              }
            }
            break

          case 'period':
            this.$refs['period.1-month'].uncheck()
            this.$refs['period.3-month'].uncheck()
            this.$refs['period.6-month'].uncheck()
            this.$refs['period.12-month'].uncheck()
            this.$refs['period.all'].uncheck()
            this.$refs['period.' + component.name].check()
            this.parseSelectedValues()
            break
        }
      },

      parseSelectedValues: function () {
        var groups = ['status', 'flags', 'period']
        var self = this

        _.each(groups, function (groupName) {
          self.localSearchConfig[groupName] = _.chain(self.$refs)
            .filter(function (value, key) {
              return key.indexOf(groupName) !== -1 && value.isChecked
            })
            .map(function (item) {
              return item.name
            })
            .value()
        })
      }
    },
    mounted () {
      _.each(['status', 'flags', 'period'], (groupName) => {
        const group = this.localSearchConfig[groupName]
        for (let key in group) {
          const value = group[key]
          this.$refs[groupName + '.' + value].check()
        }
      })
    },
    components: {
      'ui-toggle-button': UIToggleButton
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import '~scss/variables';
  @import '~foundation';

  .page-search {
    width: inherit;
    padding-bottom: 60px;

    /* Medium and up */
    @include breakpoint(large) {
      height: calc(100vh - 55px - 33px); // viewport height minus the nav / footer
      border-left: 1px solid $grey-50;
      background-color: $light;
    }

    h2.section-title {
      margin: 8px 0 0 0;
    }

    form {
      width: 100%;;

      .column {
        margin-top: 10px;
      }

      @include breakpoint(large) {
        position: relative;
        height: 100%;
        overflow-y: auto;
      }
    }

    button.ui-button[type=submit] {
      width: inherit;
      position: fixed;
      bottom: 0;
      border-radius: 0;

      @include breakpoint(large) {
        margin-top: 0;
        right: 0;
        bottom: 33px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// PageSearch.vue?51d440bc